import React from 'react';
import {createStore, applyMiddleware } from 'redux';
import { createBrowserHistory } from 'history'
//  import createHistory from 'history/createBrowserHistory'
import { routerMiddleware } from 'connected-react-router'
import rootReducer  from '../reducers';
import logger from 'redux-logger';
import { run } from '@cycle/run';
import { createCycleMiddleware } from 'redux-cycles';
import main from '../cycles/index';
import { makeHTTPDriver } from '@cycle/http';
import {persistStore, persistReducer, createMigrate} from 'redux-persist'
import storage from "redux-persist/es/storage";
import {migrations} from "./migrations";

const vpath = process.env.REACT_APP_UI_VPATH ? (process.env.REACT_APP_UI_VPATH + '/') : '';
export const history = createBrowserHistory({basename: vpath});

const middleware = routerMiddleware(history);
const cycleMiddleware = createCycleMiddleware();
const { makeActionDriver, makeStateDriver } = cycleMiddleware;
let allMiddlewares;


if(process.env.NODE_ENV !== 'production') {

	allMiddlewares = applyMiddleware(logger, middleware, cycleMiddleware);

}else{
	allMiddlewares = applyMiddleware(middleware, cycleMiddleware);
}
const store = createStore(
    persistReducer({
		blacklist:['router', 'solicitorGroup', 'articleForm', 'toba'],
		key: 'aragFrontEndPersistStoreRoot',
        storage,
		version: 20,
		migrate: createMigrate(migrations)
	}, rootReducer(history)),
    allMiddlewares
);
export const persistor = persistStore(store);

run(main, {
	ACTION: makeActionDriver(),
	STATE: makeStateDriver(),
	HTTP: makeHTTPDriver()
});

export default store;
